export const currencyMap: Record<
	string,
	{ symbol: string; position: "prefix" | "suffix" }
> = {
	SEK: { symbol: "kr", position: "suffix" },
	EUR: { symbol: "€", position: "prefix" },
	USD: { symbol: "$", position: "prefix" },
	GBP: { symbol: "£", position: "prefix" }
};
